import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionToPromise } from '@sportninja/common/actions/utils'
import inviteActions from '@sportninja/common/actions/invite'
import { authActions } from '@sportninja/common/actions/auth'

import InviteSignupScreen from '../../features/invite/signup/components/InviteSignupScreen'

/**
 * Route gate for `/invitations/:inviteId/signup` and
 * `/invitations/:inviteId/register`.
 *
 * Holds no logic of its own — it binds the redux actions and router params the
 * feature needs and hands them over. Everything else lives in
 * `features/invite/signup`.
 */
const InviteRegister = ({
  match,
  history,
  isLoggedIn,
  readInvite,
  register,
  login,
  logout,
  setNewUserInviteId,
}) => (
  <InviteSignupScreen
    inviteId={match.params.inviteId}
    isLoggedIn={isLoggedIn}
    readInvite={readInvite}
    register={register}
    login={login}
    logout={logout}
    setNewUserInviteId={setNewUserInviteId}
    redirect={history.push}
  />
)

InviteRegister.propTypes = {
  isLoggedIn: PropTypes.bool,
  readInvite: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      inviteId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  login: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  setNewUserInviteId: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {
    newUserInviteId: state.auth.login.newUserInviteId,
    isLoggedIn: state.auth.login.success,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    readInvite: bindActionToPromise(dispatch, inviteActions.read.request),
    login: bindActionToPromise(dispatch, authActions.login.request),
    logout: bindActionToPromise(dispatch, authActions.logout.request),
    register: bindActionToPromise(dispatch, authActions.register.request),

    setNewUserInviteId: bindActionToPromise(
      dispatch,
      authActions.setNewUserInviteId.request
    ),
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InviteRegister)
)
